import React from 'react';

const SvgGa = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="GA_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="GA_svg__b" fill="#fff">
        <use xlinkHref="#GA_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#GA_svg__a" />
      <path fill="#09B470" mask="url(#GA_svg__b)" d="M0 0h28v6.667H0z" />
      <path fill="#508CDE" mask="url(#GA_svg__b)" d="M0 13.333h28V20H0z" />
      <path fill="#FFD935" mask="url(#GA_svg__b)" d="M0 6.667h28v6.667H0z" />
    </g>
  </svg>
);

export default SvgGa;
